// extracted by mini-css-extract-plugin
module.exports = {"movieCard":"MovieCard_movieCard__1GLKL","movieImage":"MovieCard_movieImage__2BY_u"};